<template>
  <div class="plate-main">
    <div class="plate-wrapper">
      <div class="left">
        <slot name="left"></slot>
      </div>
      <div class="right">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "Plate"
    }
</script>

<style scoped>

  .plate-wrapper {
    display: flex;
    padding: 15px 0;
  }

  .left {
    flex-grow: 1;
    margin-right: 15px;
  }


  .right {
    width: 260px;
    flex-shrink: 0;
  }
</style>



// WEBPACK FOOTER //
// src/view/minMenu/Plate.vue